import { render, staticRenderFns } from "./brokerBanks.vue?vue&type=template&id=0b23affa"
import script from "./brokerBanks.vue?vue&type=script&lang=js"
export * from "./brokerBanks.vue?vue&type=script&lang=js"
import style0 from "./brokerBanks.vue?vue&type=style&index=0&id=0b23affa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports